<div class="content">
  <form #aufteilungsschluesselEintragenForm="ngForm">

    <header>
      <div>
      </div>

      <div class="buttons">

        <button matButton="outlined"
          data-qa="close-details-button"
          (click)="westnetzSidenavService.closeRightnav()">
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
          Schließen
        </button>

        <button matButton="filled"
          [disabled]="!aufteilungsschluesselEintragenForm.form.valid"
          data-qa="create-aufteilungsschluessel-button"
          (click)="saveAufteilungsschluessel()">
          <mat-icon>save</mat-icon>
          Speichern
        </button>

      </div>
    </header>

    @if (datenabfrage) {
      <div class="detail-main">
        <fieldset>
          <legend>Ihre Daten zur Abfrage '{{datenabfrage.bezeichnung}}'</legend>
          <mat-form-field>
            <mat-label>Aggregierte Endverbraucherlast (Referenzzeit: {{datenabfrage.referenzzeitraumEndverbraucherlast | date: 'dd.MM.yyyy'}})</mat-label>
            <input matInput
              type="number"
              #aggregierteEndverbraucherlast="ngModel"
              data-qa="aggregierteEndverbraucherlast"
              [(ngModel)]="aufteilungsschluessel.aggregierteEndverbraucherlast"
              id="aggregierteEndverbraucherlast"
              name="aggregierteEndverbraucherlast"
              required/>
            <span matSuffix>MW</span>
            @if (aggregierteEndverbraucherlast?.errors?.required) {
              <mat-error>
                Bitte tragen Sie hier einen Wert ein
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Aggregierte installierte konventionelle Erzeugerleistung (Referenzzeit: {{datenabfrage.referenzzeitraumErzeugerleistung | date: 'dd.MM.yyyy'}})</mat-label>
            <input matInput
              type="number"
              #aggregierteInstallierteKonventionelleErzeugerleistung="ngModel"
              data-qa="aggregierteInstallierteKonventionelleErzeugerleistung"
              [(ngModel)]="aufteilungsschluessel.aggregierteInstallierteKonventionelleErzeugerleistung"
              id="aggregierteInstallierteKonventionelleErzeugerleistung"
              name="aggregierteInstallierteKonventionelleErzeugerleistung"
              required/>
            <span matSuffix>MW</span>
            @if (aggregierteInstallierteKonventionelleErzeugerleistung?.errors?.required) {
              <mat-error>
                Bitte tragen Sie hier einen Wert ein
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Aggregierte installierte EEG/KWKG Erzeugerleistung (Referenzzeit: {{datenabfrage.referenzzeitraumErzeugerleistung | date: 'dd.MM.yyyy'}})</mat-label>
            <input matInput
              type="number"
              #aggregierteInstallierteEEGErzeugerleistung="ngModel"
              data-qa="aggregierteInstallierteEEGErzeugerleistung"
              [(ngModel)]="aufteilungsschluessel.aggregierteInstallierteEEGErzeugerleistung"
              [tnbResetDatenabfrageAbregelbareLeistungErrorWhenInstallierteChanged]="eegKwkgErzeugerleistungAbregelbarerAnteil"
              id="aggregierteInstallierteEEGErzeugerleistung"
              name="aggregierteInstallierteEEGErzeugerleistung"
              required/>
            <span matSuffix>MW</span>
            @if (aggregierteInstallierteEEGErzeugerleistung?.errors?.required) {
              <mat-error>
                Bitte tragen Sie hier einen Wert ein
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>EEG/KWKG Erzeugerleistung (Abregelbarer Anteil) (Referenzzeit: {{datenabfrage.referenzzeitraumErzeugerleistung | date: 'dd.MM.yyyy'}})</mat-label>
            <input matInput
              type="number"
              #eegKwkgErzeugerleistungAbregelbarerAnteil="ngModel"
              data-qa="EEG-KWKG-Erzeugerleistung-Abregelbar"
              [(ngModel)]="aufteilungsschluessel.eegKwkgErzeugerleistungAbregelbarerAnteil"
              id="eegKwkgErzeugerleistungAbregelbarerAnteil"
              [tnbDatenabfrageAbregelbareLeistungLowerEqualsInstallierte]="aggregierteInstallierteEEGErzeugerleistung.value"
              name="eegKwkgErzeugerleistungAbregelbarerAnteil"
              required/>
            <span matSuffix>MW</span>
            @if (aggregierteInstallierteEEGErzeugerleistung?.errors?.required) {
              <mat-error>
                Bitte tragen Sie hier einen Wert ein
              </mat-error>
            }
            @if (eegKwkgErzeugerleistungAbregelbarerAnteil?.errors?.tnbDatenabfrageAbregelbareLeistungLowerEqualsInstallierte) {
              <mat-error>
                Dieser Wert darf nicht höher sein als die aggregierte installierte EEG/KWKG-Erzeugerleistung
              </mat-error>
            }
          </mat-form-field>
        </fieldset>
      </div>
    }

  </form>
</div>
